/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import StyleguideView from "@/src/styleguide/components/StyleguideView/StyleguideView.tsx";
import Footer from "@/src/components/Footer/Footer.tsx";

export default function FooterStyleguide() {
  return (
    <>
      <StyleguideView fullWidth>
        <Footer />
      </StyleguideView>
    </>
  );
}
